import { useState, useEffect, Dispatch, SetStateAction } from 'react'
import { history } from 'src/commons/utils/WebCommons'
import { UnregisterCallback } from 'history'


/**
 * 
 * 当useState需要在刷新时不清空时可以使用
 * @param key 由业务方自己定义，但是要注意整个项目里面这个key是唯一的，格式最好为  `${pathname}-${business}` 由当前页面路径，以及业务组成 
 * @param defaultValue 默认值
 * @param isNeedParse 存储的时候是否需要转JSON，除了字符串类型的值 其他的都需要转JSON
 * @param depend 依赖项
 */
function usePageRefreshCache<T = string>(key: string, defaultValue?: T, isNeedParse?: boolean, depend?: any[]): [T | undefined, Dispatch<SetStateAction<T | undefined>>] {
  const [value, setValue] = useState<T | undefined>(() => {
    const finalValue = defaultValue
    let currentCache: any = localStorage.getItem(key)
    currentCache = currentCache && isNeedParse ? JSON.parse(currentCache) : currentCache
    return (typeof finalValue === 'boolean' && currentCache === false) || (typeof finalValue === 'number' && currentCache === 0) ? currentCache : currentCache as T || finalValue
  })

  useEffect(() => {
    if (!value && typeof value !== 'boolean' && typeof value !== 'number') {
      localStorage.removeItem(key)
      return
    }
    if (isNeedParse) {
      localStorage.setItem(key, JSON.stringify(value))
    } else if (typeof value === 'string') {
      localStorage.setItem(key, value)
    } else {
      // 这里理论上不会存在其他的情况， 约定就是假如类型不为string的话 isNeedParse 就应该为 true， 所以上面2个if分支已经包含了所有情况
    }
  }, [value, isNeedParse])

  useEffect(() => {
    let unlisten: UnregisterCallback
    if (depend) {
      localStorage.removeItem(key)
    } else {
      unlisten = history.listen(() => {
        localStorage.removeItem(key)
      })
    }
    return () => {
      /** 这里做个延迟清除监听事件， 是因为通过history触发的跳转会先进行跳转 然后才会被监听到， 这里假如在离开页面就清除了监听事件 会导致无法捕捉到页面跳转事件， 导致无法清除缓存 */
      setTimeout(() => {
        unlisten && unlisten()
      }, 200)
    }
  }, depend ? [...depend] : [])
  return [value, setValue]
}

export default usePageRefreshCache